import { NON_MATH_CHARACTERS } from '../../../utils/numbers'
import { InputNumberValue } from '../types/inputNumberValue'

export const sanitizeMathCharacters = (value: InputNumberValue) =>
  value?.toString().replace(NON_MATH_CHARACTERS, '') || ''
